import * as MUI from '@mui/material';
// MUI v5
// The webpack build process has static scanning,
// which needs to be changed to dynamic to avoid webpack compilation failure
// eslint-disable-next-line no-useless-concat
let Grid2 = MUI['Unstable_' + 'Grid2'];
if (!Grid2) {
    // MUI v6
    // The webpack build process has static scanning,
    // which needs to be changed to dynamic to avoid webpack compilation failure
    // eslint-disable-next-line no-useless-concat
    Grid2 = MUI['Grid' + '2'];
}
export { Grid2 };
